"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Jul 20 2018
 */

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Substituted user that is for e.g. on vacation.
 *
 * @author Radek Beran
 */


var SubstitutedUser =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SubstitutedUser, _DomainObject_1$Domai);

  function SubstitutedUser(id, username, email, firstName, lastName) {
    var _this;

    _classCallCheck(this, SubstitutedUser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SubstitutedUser).call(this));
    _this.id = id;
    _this.username = username;
    _this.email = email;
    _this.firstName = firstName;
    _this.lastName = lastName;
    return _this;
  }

  return SubstitutedUser;
}(DomainObject_1.DomainObject);

exports.SubstitutedUser = SubstitutedUser;